import debounce from 'debounce'
import { useEffect, useMemo, useRef } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyFunction = (...args: any[]) => any
export interface DebounceOptions { immediate: boolean }

export const useDebounceFn = <F extends AnyFunction>(fn: F, wait?: number, options?: DebounceOptions) => {
  const fnRef = useRef(debounce(fn, wait, options))

  // Update the debounced function when the props change
  const debouncedFn = useMemo(() => {
    fnRef.current = debounce(fn, wait, options)
    return fnRef.current
  }, [fn, wait, options])

  // Clear the debounced function when the component unmounts
  useEffect(() => {
    return () => {
      debouncedFn.clear()
    }
  }, [debouncedFn])

  return debouncedFn
}
